export default "__VITE_ASSET__DKFjjHf1__"